let config = {
  emailjs: {
    serviceID: "service_on4nrtm",
    templateID: "template_zvq21yo",
    userID: "user_9SD8umez7Ug3MCBdGOCeY"
  }
};

export default config;
